// @flow
import is from 'mz-utils/is'
import moment from 'moment'
import client from '../../client'

// Types
type ResponseType = {|
  suggested_time: string,
|}
export type Options = {
  flight_datetime: string | moment,
  flight_type?: string,
  service_type: number,
  start_lat: number,
  start_lng: number,
  end_lat: string,
  end_lng: string,
  checking_bags?: boolean,
  customs?: boolean,
}

// Constants
export const PICKUP_TIME = '/pickup/'
export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ'

/**
 * Returns suggested pickup time
 * @param  {Object} data Flight information
 * @param  {string} data.flight_datetime Flight date time
 * @param  {string} [data.flight_type=domestic] Fligh type. 'international' or 'domestic'
 * @param  {number} [data.service_type] Flight service type. 1 for To airport or 2 for From Airport
 * @param  {float} data.start_lat Flight start latitude
 * @param  {float} data.start_lng Flight start longitude
 * @param  {float} data.end_lat Flight end latitude
 * @param  {float} data.end_lng Flight end longitude
 * @param  {boolean} [data.checking_bags=true] Flight has checking bags
 * @param  {boolean} [data.customs=false] Flight has customs
 * @return {Promise|Error} A resolved Promise with the pickup time or Rejected with an Error.
 */
export const getPickupTime = (data: Options): Promise<moment> => {
  const defaultValues = {
    flight_type: 'domestic',
    checking_bags: true,
    customs: false,
  }

  const flighDatetime = is.string(data.flight_datetime)
    ? moment(data.flight_datetime, 'MM/DD/YYYY hh:mm A').format(DATE_FORMAT)
    : (data.flight_datetime: moment).format(DATE_FORMAT)

  const query = {
    ...defaultValues,
    ...data,
    flight_datetime: flighDatetime,
  }

  return client
    .post(PICKUP_TIME, { body: query })
    .then((response: ResponseType) =>
      moment.parseZone(response.suggested_time, DATE_FORMAT)
    )
}

export default getPickupTime
